namespace GeniuzPOS.Product {
    export namespace CsPluService {
        export const baseUrl = 'Product/CsPlu';

        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumberEAN(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CsPluRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CsPluRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetNextNumber = "Product/CsPlu/GetNextNumber",
            GetNextNumberEAN = "Product/CsPlu/GetNextNumberEAN",
            Retrieve = "Product/CsPlu/Retrieve",
            List = "Product/CsPlu/List"
        }

        [
            'GetNextNumber', 
            'GetNextNumberEAN', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CsPluService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
